import React from 'react'
import Footer from '../controls/Footer'

const getDesc=(val)=>{
    return(
      (val && val.toUpperCase()==='Y')? 'Yes' : (val && val.toUpperCase()==='N')? 'No':  (val && val.toUpperCase()==='/')? 'N/A' : ''
    )
}

class PrintFullPhy extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
     const record= this.props.record
     const classes = this.props.classes
     return(
        <div className={classes.root}>
          

            <table className={classes.tableOuter}>
            <tbody>
                <tr>
                <td>
                <div className={classes.title}>Full-length Donor History Questionnaire</div>
                
                    <table className={classes.tableNoBorder} cellPadding="5">
                    <tbody>               
                    <tr>
                        <td><b>CENTER:</b>&nbsp;&nbsp;&nbsp;{record.location}</td>
                        <td><b>TYPE:</b>&nbsp;&nbsp;&nbsp;{record.type}</td>
                    </tr>
                    <tr>
                        <td ><b>DONOR NAME:</b>&nbsp;&nbsp;&nbsp;{record.last_name + ',  ' + record.first_name + '  ' + ((record && record.middle_name )?  record.middle_name : '' )}</td>
                        <td><b>DONOR #:</b>&nbsp;&nbsp;&nbsp;{record.ssn}</td>
                    </tr>
                    </tbody>
                    </table>
                    </td>
                </tr>
                <tr>
                    <td>
                    <table className={classes.table} border="1" cellPadding="5">
                        <tbody >
                        <tr>
                            <td >&nbsp;</td><th >Yes/No</th>
                        </tr>
                        <tr >
                            <td colSpan="2"  bgcolor="silver">&nbsp;&nbsp;<b>Are you</b></td>
                        </tr>
                        <tr> 
                            <td>1.	Feeling healthy and well today? </td><td> { getDesc(record.f_healthy) } </td>
                        </tr>
                        <tr  id= 'hq_2' > 
                            <td>2.	Currently taking an antibiotic or other medication for an infection?</td><td> { getDesc(record.f_antibiotic) }  </td>      

                        </tr >
                        <tr id= 'hq_3' >
                            <td>3.	Currently taking any other medications?</td><td> { getDesc(record.f_other_med) }  </td>
                        </tr>
                        <tr  id= 'hq_4' >
                            <td  colSpan="2" bgcolor="silver">&nbsp;&nbsp;<b>Please read the medication list.</b></td>
                        </tr>
                        <tr id= 'hq_5' >
                            <td>4.	Have you taken any medications on the medication list in the time frames indicated?</td><td> { getDesc(record.f_taken_med) } </td>
                        </tr>
                        <tr id= 'hq_6' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;<b>Please review the Risk Poster</b></td>
                            </tr>
                        <tr id= 'hq_6' > 
                            <td>5.	Did you review the Risk Poster?</td><td> { getDesc(record.f_risk) }    </td>
                        </tr>
                        <tr  id= 'hq_7' > 
                            <td>6.	Do you have any questions about anything mentioned on the Risk Poster?</td><td> { getDesc(record.f_quest_med) }   </td>

                        </tr>
                        <tr id= 'hq_8' >
                            <td colSpan="2" bgcolor="silver">In the past <b>two months, have you </b></td>
                        </tr>
                        <tr id= 'hq_9' > 
                            <td>7.	Had any vaccinations or other shots?</td><td> { getDesc(record.f_vaccination) }   </td>
                        </tr>
                        <tr id= 'hq_10'  > 
                            <td>8.	Had contact with someone who was vaccinated for smallpox in the past 8 weeks?</td><td> { getDesc(record.f_smallpox) } </td>
                        </tr>
                        <tr id= 'hq_11' > 
                            <td>9. Donated whole blood, platelets or plasma at another center?</td><td> { getDesc(record.f_another_center) } </td>
                        </tr>
                        <tr id= 'hq_12' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;In the past <b>three months</b>, have you</td>
                            </tr>
                        <tr id= 'hq_13' > 
                            <td>10.	Had a blood transfusion or received other blood products?</td><td> { getDesc(record.f_transfusion) } </td>
                        </tr>
                        <tr id= 'hq_14' > 
                            <td> label = "11.	Come into contact with someone else's blood?"</td> <td> { getDesc(record.f_contact_blood) }  </td>
                        </tr>
                        <tr id= 'hq_15' > 
                            <td>12. Had an accidental needle-stick involving exposure to blood?</td><td> { getDesc(record.f_needle) }  </td>
                        </tr>
                        <tr id= 'hq_16'> 
                            <td>13.	Had sexual contact with anyone who has ever had HIV or has ever had a positive test for HIV virus?</td><td> { getDesc(record.f_sex_contact_hiv) } </td>
                        </tr>
                        <tr id= 'hq_17'> 
                            <td>14.	Received money, drugs, or other payment for sex?</td><td> { getDesc(record.f_money_sex) }  </td>
                        </tr>
                        <tr id= 'hq_18'> 
                            <td>15. Had sexual contact with a prostitute or anyone else who takes money or drugs or other payment for sex?</td><td> { getDesc(record.f_sex_contact_pay) }   </td>
                        </tr>
                        <tr id= 'hq_19'> 
                            <td>16.	Used needles to take drugs, steroids, or anything not prescribed by your doctor?</td><td> { getDesc(record.f_used_needle) }  </td>
                        </tr>
                        <tr id= 'hq_20' > 
                            <td>17. Had sexual contact with anyone who has ever used needles to take drugs or steroids, or anything not prescribed by their doctor?</td><td> { getDesc(record.f_sex_contact_used_needle) }  </td>                          
                        </tr>
                        <tr id= 'hq_21'> 
                            <td>18.	Female Donors: Had sexual contact with a male who had sexual contact with another male in the past 3 months?</td><td> { getDesc(record.f_female_male_male) } </td>
                        </tr>
                        <tr id= 'hq_22'> 
                            <td>19.	Gotten a tattoo or had one touched-up?</td><td> { getDesc(record.f_tattoo) } </td>
                        </tr>
                        <tr id= 'hq_23'> 
                            <td>20.	Had an ear or body piercing?</td><td> { getDesc(record.f_piercing) } </td>
                        </tr>
                        <tr id= 'hq_24' > 
                            <td>21.	Had or been treated for syphilis or gonorrhea?</td><td> { getDesc(record.f_syphillis) } </td>
                        </tr>
                        <tr id= 'hq_25' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;In the past <b>four months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_26'> 
                            <td>22. Donated a double unit of red blood cells using an apheresis machine?</td><td> { getDesc(record.f_double_unit) }  </td>

                        </tr>
                        <tr id= 'hq_27'> 
                            <td>23. Had surgery or a diagnostic, medical or dental procedure?</td><td> { getDesc(record.f_surgery) } </td>

                        </tr>
                        <tr id= 'hq_28'> 
                            <td>24. Had acupuncture?</td><td> { getDesc(record.f_acupuncture) }  </td>

                        </tr>
                        <tr id= 'hq_29' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;In the past <b>six months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_30'> 
                            <td>25. Female Donors: been pregnant or are you pregnant now?</td><td> { getDesc(record.f_pregnant) } </td>

                        </tr>
                        <tr id= 'hq_31' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;In the past <b>12 months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_32'> 
                            <td>26. Received during surgery bone, tissue or skin?</td><td> { getDesc(record.f_received_tissue) }  </td>

                        </tr>
                        <tr id= 'hq_33'> 
                            <td>27.	Had sexual contact with a person who has hepatitis?</td><td> { getDesc(record.f_sex_hep) }</td>
                        </tr>
                        <tr id= 'hq_34'> 
                            <td>28.	Been in juvenile detention, lockup, jail, or prison for 72 hours or more consecutively?</td><td> { getDesc(record.f_jail) }  </td>

                        </tr>                        
                        <tr id= 'hq_35' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;From <b>1980 through 1996</b>, did you</td>
                        </tr>
                        <tr id= 'hq_36'> 
                            <td>29.	Spend time that adds up to 3 months or more in England, Northern Ireland, Scotland, Wales, the Isles of Man, the Channel Islands, Gibraltar, or the Falkland Islands?</td>
                            <td> { getDesc(record.f_uk) }  </td>

                        </tr>
                        </tbody>
                    </table>
                    <table className={classes.printOnly} border="0" cellPadding="5">
                        <tbody>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        <tr className={classes.printOnly}><td colSpan='2'></td></tr>
                        </tbody>
                    </table>
                    <table className={classes.table} border="1" cellPadding="5">
                        <tbody>
                        <tr> 
                            <th>&nbsp;</th><th>Yes/No</th>
                        </tr>
                        <tr id= 'hq_37' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;From <b>1980 through 2001</b>, did you</td>
                        </tr>
                        <tr id= 'hq_38'> 
                            <td>30.	Spend time that adds up to 5 years or more in France or Ireland? Time spent in Ireland does not include time spent in Northern Ireland which is part of the United Kingdom?</td>
                            <td> { getDesc(record.f_france) } </td>

                        </tr>
                        <tr id= 'hq_39' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;From <b>1980 through the present</b>, did you</td>
                        </tr>
                        <tr id= 'hq_40'> 
                            <td>31.	Receive a blood transfusion in France, Ireland, England, Northern Ireland, Scotland, Wales, the Isle of Man, the Channel Islands, Gibraltar, or the Falkland Islands?</td>
                            <td> { getDesc(record.f_blood_uk) }  </td>

                        </tr>
                        <tr id= 'hq_41' >
                            <td colSpan="2" bgcolor="silver">&nbsp;&nbsp;Have you <b>EVER</b></td>
                        </tr>
                        <tr id= 'hq_42'> 
                            <td>32.	Had a positive test for HIV?</td><td> { getDesc(record.f_had_hiv) } </td>
                        </tr>
                        <tr id= 'hq_43'> 
                            <td>33.	Had a transplant such as an organ or bone marrow?</td><td> { getDesc(record.f_had_transplant) } </td>

                        </tr>
                        <tr id= 'hq_44'> 
                            <td>34.	Received a dura mater (or brain covering) graft?</td><td> { getDesc(record.f_graft) }   </td>
                        </tr>
                        <tr id= 'hq_45'> 
                            <td>35.	Had any type of cancer, including leukemia?</td><td> { getDesc(record.f_had_cancer) }  </td>

                        </tr>
                        <tr id= 'hq_46'> 
                            <td>36.	Had any problem with your heart or lungs?</td><td> { getDesc(record.f_prob_heart) }   </td>

                        </tr>
                        <tr id= 'hq_47'> 
                            <td>37.	Had any problem with your liver or kidneys?</td><td> { getDesc(record.f_prob_liver) }  </td>

                        </tr>
                        <tr id= 'hq_48'> 
                            <td>38. Had a bleeding condition or a blood disease?</td><td> { getDesc(record.f_had_bleeding) } </td>

                        </tr>
                        <tr id= 'hq_49'> 
                            <td>39.	Had a transplant or other medical procedure that involved being exposed to live cells, tissues or organs from an animal (xenotransplant)?</td>
                            <td> { getDesc(record.f_animal) }   </td>

                        </tr>
                        <tr id= 'hq_50'> 
                            <td>40. Male Donors: Have you ever had sexual contact with another male?</td><td> { getDesc(record.f_sex_male_male) }   </td>

                        </tr>
                        <tr id= 'hq_51'> 
                            <td>41. Have you ever had any type of nervous system disease?</td><td> { getDesc(record.f_nervous) }    </td>

                        </tr>
                        <tr id= 'hq_52'> 
                            <td>42. Have you ever had a history of recurrent episodes of fainting?</td><td> { getDesc(record.f_fainting) }    </td>

                        </tr>
                        <tr id= 'hq_53'> 
                            <td>43. Have you ever had a history of seizures or convulsions?</td><td> { getDesc(record.f_seizures) }   </td>

                        </tr>
                        <tr id= 'hq_54'> 
                            <td>44. Have you ever been diagnosed with diabetes?</td><td> { getDesc(record.f_diabetes) }  </td>

                        </tr>
                        <tr id= 'hq_55'> 
                            <td>45. Have you ever been diagnosed with any other serious active, chronic, or relapsing disease?</td><td> { getDesc(record.f_chronic) }    </td>
                        </tr>
                        <tr id= 'hq_56'> 
                            <td>46. Have any of your relatives had Creutzfeld-Jakob disease?</td><td> { getDesc(record.f_relative) }   </td>
                        </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <Footer >
                <p>Edonorsoft SOP Form No. 03.10.07, Effective 05-27-20 (Ref: PPTA DHQ V2.1 May 2020)</p>
            </Footer>

    </div>
     )
    }
}

export default PrintFullPhy